import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MwPagesDataResolveService } from './pages/pages-data-resolve.service';
import { MwAuthGuard } from '@core/auth/services/guards/auth.guard';
import { MwCompanyGuard } from '@core/auth/services/guards/company.guard';
import { MwLayoutComponent } from './@layout/layout.component';
import { MwLayoutModule } from './@layout';

export const AppRoutePath = {
  Default: 'pages/assignments',
};

// Routes tree
export const routes: Routes = [
  {
    path: 'company-selector',
    loadChildren: () =>
      import('./@shared/@pages/company-selector/company-selector.module').then(
        (m) => m.CompanySelectorModule
      ),
  },
  {
    path: 'user-profile',
    loadChildren: () =>
      import('./@shared/@pages/user-profile/user-profile.module').then((m) => m.UserProfileModule),
  },
  {
    path: 'no-access',
    children: [
      {
        path: '',
        component: MwLayoutComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import('../@core/@auth-pages/no-access/no-access.module').then((m) => m.NoAccessModule),
          },
        ],
      },
    ],
  },
  {
    path: 'unauthorized',
    children: [
      {
        path: '',
        component: MwLayoutComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import('../@core/@auth-pages/unauthorized/unauthorized.module').then((m) => m.UnauthorizedModule),
          },
        ],
      },
    ],
  },
  {
    path: 'pages',
    loadChildren: () =>
      import('./pages/pages.module').then((m) => m.PagesModule),
    canActivate: [MwAuthGuard],
    canLoad: [MwCompanyGuard],
    resolve: {
      data: MwPagesDataResolveService,
    },
  },
  {
    path: '',
    redirectTo: AppRoutePath.Default,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    MwLayoutModule.forRoot([]),
    RouterModule.forRoot(routes, {
    useHash: true
}),
  ],
  exports: [RouterModule],
  providers: [MwPagesDataResolveService],
})
export class AppRoutingModule {}
